const CONTROLLER_TYPE = 'CONTROLLER'
const OPERATOR_TYPE = 'OPERATOR'
const SUBOPERATOR_TYPE = 'SUBOPERATOR'
const CO_CONTROLLER_TYPE = 'CO_CONTROLLER'

const CONTROLLER_LABEL = 'Controlador'
const OPERATOR_LABEL = 'Operador'
const SUBOPERATOR_LABEL = 'Suboperador'
const CO_CONTROLLER_LABEL = 'Co-controlador'

const OPTIONS_TYPES = [
  { id: CONTROLLER_TYPE, name: CONTROLLER_LABEL },
  { id: OPERATOR_TYPE, name: OPERATOR_LABEL },
  { id: SUBOPERATOR_TYPE, name: SUBOPERATOR_LABEL },
  { id: CO_CONTROLLER_TYPE, name: CO_CONTROLLER_LABEL },
]

const TRANSLATED_TYPE = {
  CONTROLLER: CONTROLLER_LABEL,
  OPERATOR: OPERATOR_LABEL,
  SUBOPERATOR: SUBOPERATOR_LABEL,
  CO_CONTROLLER: CO_CONTROLLER_LABEL,
}

const dataTreatmentAgent = {
  CO_CONTROLLER_LABEL,
  CO_CONTROLLER_TYPE,
  CONTROLLER_LABEL,
  CONTROLLER_TYPE,
  OPERATOR_LABEL,
  OPERATOR_TYPE,
  OPTIONS_TYPES,
  SUBOPERATOR_LABEL,
  SUBOPERATOR_TYPE,
  TRANSLATED_TYPE,
}

export default dataTreatmentAgent
